import Link from "next/link";

/** 기존 26년 3회 상품에 공개된 과거 회차 실적. */
export default function SummaryPdfTrackRecord({ theory, coding }: { theory: boolean; coding: boolean }) {
  const theoryRecord = (
    <div className="break-words rounded-xl border border-purple-200 bg-purple-50 p-4 dark:border-purple-900 dark:bg-purple-950/40">
      <h2 className="mb-2 text-sm font-semibold text-purple-800 dark:text-purple-300">
        🏆 이론 요약 PDF 적중 실적
      </h2>
      <ul className="space-y-1.5 text-xs text-gray-700 dark:text-gray-300">
        <li className="flex items-start gap-1.5">
          <span aria-hidden="true" className="text-purple-500 dark:text-purple-400">
            ✓
          </span>
          <span>
            <strong>25년 2회</strong> 이론 11문제 중{" "}
            <strong className="text-purple-700 dark:text-purple-300">9문제</strong>
          </span>
        </li>
        <li>
          <Link
            href="/past-exam/2025/2025-3-review"
            aria-label="25년 3회 이론 12문제 중 9문제 적중 — 적중 상황 자세히 보기"
            className="group flex flex-col gap-0.5 rounded-md border border-purple-200 bg-purple-100/60 px-2 py-1.5 transition-colors hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 dark:border-purple-900 dark:bg-purple-900/30 dark:hover:bg-purple-900/50"
          >
            <span className="flex items-start gap-1.5">
              <span aria-hidden="true" className="text-purple-500 dark:text-purple-400">
                ✓
              </span>
              <span>
                <strong>25년 3회</strong> 이론 12문제 중{" "}
                <strong className="text-purple-700 dark:text-purple-300">9문제</strong>
              </span>
            </span>
            <span className="pl-4 font-semibold text-purple-700 dark:text-purple-300">
              자세히 보기
              <span aria-hidden="true" className="ml-0.5 inline-block transition-transform group-hover:translate-x-0.5">
                &rarr;
              </span>
            </span>
          </Link>
        </li>
        <li>
          <Link
            href="/past-exam/2026/2026-1-review"
            aria-label="26년 1회 이론 13문제 중 8문제 적중 — 적중 상황 자세히 보기"
            className="group flex flex-col gap-0.5 rounded-md border border-purple-200 bg-purple-100/60 px-2 py-1.5 transition-colors hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 dark:border-purple-900 dark:bg-purple-900/30 dark:hover:bg-purple-900/50"
          >
            <span className="flex items-start gap-1.5">
              <span aria-hidden="true" className="text-purple-500 dark:text-purple-400">
                ✓
              </span>
              <span>
                <strong>26년 1회</strong> 이론 13문제 중{" "}
                <strong className="text-purple-700 dark:text-purple-300">8문제</strong>
              </span>
            </span>
            <span className="pl-4 font-semibold text-purple-700 dark:text-purple-300">
              자세히 보기
              <span aria-hidden="true" className="ml-0.5 inline-block transition-transform group-hover:translate-x-0.5">
                &rarr;
              </span>
            </span>
          </Link>
        </li>
        <li>
          <Link
            href="/past-exam/2026/2026-2-review"
            aria-label="26년 2회 이론 9문제 중 8문제 적중 — 적중 상황 자세히 보기"
            className="group flex flex-col gap-0.5 rounded-md border border-purple-200 bg-purple-100/60 px-2 py-1.5 transition-colors hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 dark:border-purple-900 dark:bg-purple-900/30 dark:hover:bg-purple-900/50"
          >
            <span className="flex items-start gap-1.5">
              <span aria-hidden="true" className="text-purple-500 dark:text-purple-400">
                ✓
              </span>
              <span>
                <strong>26년 2회</strong> 이론 9문제 중{" "}
                <strong className="text-purple-700 dark:text-purple-300">8문제</strong>
              </span>
            </span>
            <span className="pl-4 font-semibold text-purple-700 dark:text-purple-300">
              자세히 보기
              <span aria-hidden="true" className="ml-0.5 inline-block transition-transform group-hover:translate-x-0.5">
                &rarr;
              </span>
            </span>
          </Link>
        </li>
      </ul>
      <p className="mt-2 text-xs font-semibold text-purple-700 dark:text-purple-300">
        26년 2회 기준, 이론 40점 분량의 주제가 수록됐어요.
      </p>
    </div>
  );

  const codingRecord = (
    <div className="break-words rounded-xl border border-purple-200 bg-purple-50 p-4 dark:border-purple-900 dark:bg-purple-950/40">
      <h2 className="mb-2 text-sm font-semibold text-purple-800 dark:text-purple-300">
        🏆 코딩 요약 PDF 적중 실적
      </h2>
      <ul className="space-y-1.5 text-xs text-gray-700 dark:text-gray-300">
        <li>
          <Link
            href="/past-exam/2026/2026-2-review"
            aria-label="26년 2회 코딩 11문제 중 8문제 적중 — 적중 상황 자세히 보기"
            className="group flex flex-col gap-0.5 rounded-md border border-purple-200 bg-purple-100/60 px-2 py-1.5 transition-colors hover:bg-purple-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 dark:border-purple-900 dark:bg-purple-900/30 dark:hover:bg-purple-900/50"
          >
            <span className="flex items-start gap-1.5">
              <span aria-hidden="true" className="text-purple-500 dark:text-purple-400">
                ✓
              </span>
              <span>
                <strong>26년 2회</strong> 코딩 11문제 중{" "}
                <strong className="text-purple-700 dark:text-purple-300">8문제</strong>
              </span>
            </span>
            <span className="pl-4 font-semibold text-purple-700 dark:text-purple-300">
              자세히 보기
              <span aria-hidden="true" className="ml-0.5 inline-block transition-transform group-hover:translate-x-0.5">
                &rarr;
              </span>
            </span>
          </Link>
        </li>
      </ul>
      <p className="mt-2 text-xs text-gray-600 dark:text-gray-400">
        SQL 포함 · 일부 개념만 수록된 2문제 제외
      </p>
      <p className="mt-2 text-xs font-semibold text-purple-700 dark:text-purple-300">
        26년 2회 기준, 코딩 40점 분량의 주제가 수록됐어요.
      </p>
    </div>
  );

  return <section aria-label="요약 PDF 적중 실적" className="space-y-4">{theory && theoryRecord}{coding && codingRecord}</section>;
}
